import { render, staticRenderFns } from "./HPTestDataStatistc.vue?vue&type=template&id=124439c1"
import script from "./HPTestDataStatistc.vue?vue&type=script&lang=js"
export * from "./HPTestDataStatistc.vue?vue&type=script&lang=js"
import style0 from "./HPTestDataStatistc.vue?vue&type=style&index=0&id=124439c1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports